var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fee-list-table" },
    [
      _vm.fees.length
        ? _c("b-table", {
            attrs: {
              fields: _vm.fields,
              items: _vm.tableItems,
              responsive: "",
              striped: "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "table-colgroup",
                  fn: function (scope) {
                    return _vm._l(scope.fields, function (field) {
                      return _c("col", {
                        key: field.key,
                        style: { width: field.width ?? "auto" },
                      })
                    })
                  },
                },
                {
                  key: "cell(amountPaid)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        {
                          class: _vm.getAmountPaidClasses(data.item.amountPaid),
                        },
                        [
                          data.item.hasAmountAdjustmentGross
                            ? [_vm._v("* ")]
                            : _vm._e(),
                          _vm._v(_vm._s(data.value) + "\n            "),
                        ],
                        2
                      ),
                    ]
                  },
                },
                {
                  key: "cell(amountOpen)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        {
                          class: _vm.getAmountOpenClasses(data.item.amountOpen),
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(data.value) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(paymentComment)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        { staticStyle: { "white-space": "pre-wrap" } },
                        [_vm._v(_vm._s(data.value))]
                      ),
                    ]
                  },
                },
                {
                  key: "cell(actions)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "table-actions mb-2",
                          staticStyle: { "text-align": "left" },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "#", title: "Details anzeigen" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.$emit("fee-details", data.item.id)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "inticon-autoclaim_detail",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          data.item.permissions.canEdit
                            ? _c(
                                "a",
                                {
                                  attrs: { href: "#", title: "Bearbeiten" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.$emit("fee-edit", data.item.id)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "inticon-autoclaim_bearbeiten",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          data.item.permissions.canDelete
                            ? _c(
                                "a",
                                {
                                  attrs: { href: "#", title: "Löschen" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.$emit(
                                        "fee-delete",
                                        data.item.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "inticon-autoclaim_loschen",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3368985175
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.fees.length === 0
        ? _c("b-alert", { attrs: { show: "", variant: "info" } }, [
            _vm._v("\n        Keine Kostennoten vorhanden.\n    "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }